import { lazy } from 'react';

const JournalEntriesPage = lazy(() => import('../pages/JournalEntries.page'));
const AddJournalEntryPage = lazy(() => import('../pages/AddJournalEntry.page'));

const JournalEntriesRoutes = [
    {
        path: '/journal-entries',
        element: <JournalEntriesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/journal-entries/add',
        element: <AddJournalEntryPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { JournalEntriesRoutes };
